module.exports = __webpack_public_path__ + "static/img/230825_BB_CherryLemonade_Smiley_Anim01_1.882d79c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/230825_BB_CherryLemonade_Smiley_Anim01_1.gif
// module id = v+cL
// module chunks = 0